import axios from "axios";

const API_URL = "https://api.svisiontv.com/api/admin"; // Change for production

const login = async (email, password) => {
    const response = await axios.post(
      `${API_URL}/login`, 
      { email, password }, 
      { withCredentials: true } // ✅ Ensures cookies are sent
    );
    return response.data;
  };
  
const logout = () => {
  localStorage.removeItem("adminToken");
};

const getCurrentAdmin = () => {
  return localStorage.getItem("adminToken");
};

export default { login, logout, getCurrentAdmin };
